<template>
  <div>
    <div class="col-6" style="padding: 0;">
        <div class="box-mini mb-15">
          <table>
            <tr style="text-align: center;">
              <td
                class="is-weeks-not-selected"
                v-for="we in setWeeksDefaultList"
                :key="we.w"
                @click="onChangeWeeks(we.w)"
                :class="{
                  'is-weeks-selected': we.w == setWeeks ? true : false,
                }"
              >
                Week {{ we.w }}
              </td>
            </tr>
          </table>
        </div>
      </div>
  </div>

</template>
<style lang="scss" scoped>
.detail-data-all {
  display: block;
  height: 45px;
  max-height: 45px;
  overflow: auto;
}

table {
  width: 100%;
  font-size: 10px;
}

td {
  // outline:1px solid #ccc;
  height: 45px;
  max-height: 30px;
}

// tr:nth-child(even){background-color: #f2f2f2;}

td,
th {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
  // padding: 8px;
  padding: 0;
  border-left: none;
}

th {
  background-color: #2f353a;
  padding: 5px;
}

.class-selected:hover {
  // background-color: #ffb326;
  background-color: #ffb326;
  cursor: pointer;
}

.is-weeks-not-selected {
  cursor: pointer;
}

.is-weeks-not-selected:hover {
  cursor: pointer;
  background-color: #ffb326;
  color: white;
}

.is-weeks-selected {
  background-color: #ffb326;
  cursor: pointer;
  color: white;
}
</style>

<script>
  export default {
    props:['setWeeks'],
    data() {
      return {
        setWeeksDefaultList: [
          {
            w: 1,
          },
          {
            w: 2,
          },
          {
            w: 3,
          },
          {
            w: 4,
          },
          {
            w: 5,
          },
        ],
      }
    },
  }
</script>
